import { render, staticRenderFns } from "./RolesAdminTable.vue?vue&type=template&id=4fda992c"
import script from "./RolesAdminTable.vue?vue&type=script&lang=js"
export * from "./RolesAdminTable.vue?vue&type=script&lang=js"
import style0 from "./RolesAdminTable.vue?vue&type=style&index=0&id=4fda992c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports